import { Pipe, PipeTransform } from '@angular/core';

import { TipoClassificacaoGrupoCadastro } from '../tipo-classificacao-grupo-cadastro';
import { TipoClassificacao } from '../tipo-classificacao';

@Pipe({
    name: 'tipoClassificacaoGrupoCadastro',
    pure: false
})
export class TipoClassificacaoGrupoCadastroPipe implements PipeTransform {

    /** Obtem o tipo de classificação informado nos grupos de cadastros */
    transform(grupos: TipoClassificacaoGrupoCadastro[], idTipoClassificacao: number): TipoClassificacao {
        if (!grupos) {
            return null;
        }

        // Percorrendo os grupos
        for (let i = 0; i < grupos.length; i++) {
            const grupo = grupos[i];
            // Percorrendo os tipos de classificações
            for (let j = 0; j < grupo.tiposClassificacoes?.length; j++) {
                const tipoClassificacao = grupo.tiposClassificacoes[j];
                if (tipoClassificacao.id === idTipoClassificacao) {
                    return tipoClassificacao;
                }
            }
        }

        return null;
    }
}
